import { createSlice } from '@reduxjs/toolkit';

export const reportOptionsSlice = createSlice({
    name: "reportOptions",
    initialState: null,
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const reportOptionsActions = reportOptionsSlice.actions;

export default reportOptionsSlice.reducer;